//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fieldBase from "@/mixins/field-base";
import countries from "@/src/countries";
export default {
  mixins: [fieldBase],
  components: {
    Multiselect: async () => import("vue-multiselect").then((x) => x.default),
  },
  props: {
    fieldIndex: {
      required: false,
      default: "",
    },
    field: {
      required: true,
    },
    disabled: {
      required: false,
    },
    value: {
      required: true,
    },
    validationContext: {
      required: true,
    },
  },
  data() {
    return {
      localValue: this.value,
      options: countries,
    };
  },
  watch: {
    localValue: {
      handler(newValue) {
        this.$emit("input", newValue);
      },
      deep: true,
    },
  },
  methods: {
    // The search box takes free text but isn't an answer, so Hindsight masks it with plain mask (length and validity
    // only), not the answer fields' mask-value; the chosen countries stay recorded. vue-multiselect has no prop for
    // the input's attributes, so the marker goes on it once mounted.
    maskSearch() {
      const search = this.$refs.multiselect && this.$refs.multiselect.$refs.search;
      if (search) search.setAttribute("data-hs-privacy", "mask");
    },
  },
};
